import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Card, CardActionArea, Tooltip, Typography } from '@mui/material';
import React from 'react';

type SectionCardProps = {
  title: string;
  description: string;
  info?: string;
  selected: boolean;
  onToggle: () => void;
};

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  info,
  selected,
  onToggle,
}) => {
  return (
    <Card
      sx={(theme) => ({
        borderRadius: 3,
        border: '2px solid',
        borderColor: selected
          ? theme.palette.primary.main
          : theme.palette.grey[300],
        backgroundColor: theme.palette.background.paper,
        transition:
          'background-color 0.18s ease-out, border-color 0.18s ease-out',
        boxShadow: 'none',
        '&:hover': {
          borderColor: selected
            ? theme.palette.primary.main
            : theme.palette.grey[400],
          backgroundColor: theme.palette.action.hover,
        },
      })}
    >
      <CardActionArea
        onClick={onToggle}
        sx={{
          px: 1.25,
          py: 0.75,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              fontWeight={600}
              noWrap
              sx={(theme) => ({
                color: selected
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
              })}
            >
              {title}
            </Typography>
            <Typography
              variant="caption"
              component="p"
              noWrap
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                lineHeight: 1.4,
              })}
            >
              {description}
            </Typography>
          </Box>
          {info && (
            <Tooltip
              placement="top"
              enterDelay={150}
              title={
                <Box
                  sx={{
                    bgcolor: 'white',
                    p: 1.25,
                    borderRadius: 2,
                    border: 1,
                    borderColor: 'divider',
                    maxWidth: 260,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: 'text.primary',
                      mb: 0.25,
                    }}
                  >
                    Consulta pagada
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontWeight: 400,
                    }}
                  >
                    {info}
                  </Typography>
                </Box>
              }
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'transparent',
                    padding: 0,
                    boxShadow: 'none',
                    border: 'none',
                  },
                },
              }}
            >
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                <InfoIcon
                  color={selected ? 'warning' : 'action'}
                  sx={{ fontSize: 18 }}
                />
              </Box>
            </Tooltip>
          )}
          {selected && (
            <Box
              sx={(theme) => ({
                width: 22,
                height: 22,
                borderRadius: 1,
                bgcolor: theme.palette.primary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              <CheckIcon
                sx={(theme) => ({
                  fontSize: 16,
                  color: theme.palette.common.white,
                })}
              />
            </Box>
          )}
        </Box>
      </CardActionArea>
    </Card>
  );
};
